export default __webpack_public_path__ + "static/media/security.40778384.jpg";